// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-card_game-card__NAu\\+L {
  padding: 12px;
  background-color: var(--white-text-color);
  border-radius: 6px;
  width: inherit;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 18px;
}

.game-card_card-header__l50Ff {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.game-card_card-content__GK9k4 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.game-card_game-data__BO6W1 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  justify-items: center;
}

.game-card_score__PpM7- {
  width: fit-content;
  background-color: var(--primary-text-color);
  border-radius: 4px;
  padding: 4px 6px;
  height: min-content;
}

.game-card_score-content__qHUBa {
  color: var(--white-text-color);
}

.game-card_data-container__2YO4W {
  display: flex;
  justify-content: center;
  align-items: center;
}

.game-card_data__5KjeQ {
  display: grid;
  grid-template-rows: 20px 1fr;
  text-align: center;
  gap: 8px;

  & img {
    justify-self: center;
  }

  & p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.game-card_empty-game-card__jAhNJ {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed var(--primary-border-color);
  border-radius: 6px;
  text-align: center;
  padding: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/game-card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,QAAQ;;EAER;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".game-card {\n  padding: 12px;\n  background-color: var(--white-text-color);\n  border-radius: 6px;\n  width: inherit;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  gap: 18px;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.card-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.game-data {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  justify-items: center;\n}\n\n.score {\n  width: fit-content;\n  background-color: var(--primary-text-color);\n  border-radius: 4px;\n  padding: 4px 6px;\n  height: min-content;\n}\n\n.score-content {\n  color: var(--white-text-color);\n}\n\n.data-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.data {\n  display: grid;\n  grid-template-rows: 20px 1fr;\n  text-align: center;\n  gap: 8px;\n\n  & img {\n    justify-self: center;\n  }\n\n  & p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.empty-game-card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px dashed var(--primary-border-color);\n  border-radius: 6px;\n  text-align: center;\n  padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"game-card": `game-card_game-card__NAu+L`,
	"card-header": `game-card_card-header__l50Ff`,
	"card-content": `game-card_card-content__GK9k4`,
	"game-data": `game-card_game-data__BO6W1`,
	"score": `game-card_score__PpM7-`,
	"score-content": `game-card_score-content__qHUBa`,
	"data-container": `game-card_data-container__2YO4W`,
	"data": `game-card_data__5KjeQ`,
	"empty-game-card": `game-card_empty-game-card__jAhNJ`
};
export default ___CSS_LOADER_EXPORT___;
